import React from 'react';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Input,
    InputGroup,
    InputGroupText,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import {
    getTreatAsRemoved,
    onAdminQuantityChange,
    onFieldUserQuantityChange,
} from './TimesheetDetail';
import { toNumberSafe } from '../utilities/NumberHelpers';
import { areTimesSet } from './CrewTimesheet';
import AdjustmentDetail from './AdjustmentDetail';

export default class TimesheetDetailContractPhaseButton
    extends React.Component
{
    constructor(props) {
        super(props);

        this.state = { showModal: false };

        this.toggleModal = this.toggleModal.bind(this);
    }

    isEditEnabled() {
        const { timesheet, timesheetDetail } = this.props;

        return areTimesSet(timesheet) && !getTreatAsRemoved(timesheetDetail);
    }

    toggleModal() {
        const { timesheetDetail } = this.props;

        const isRemoved = getTreatAsRemoved(timesheetDetail);

        if (isRemoved || !this.isEditEnabled()) {
            this.setState({ showModal: false });
            return;
        }

        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    }

    getDetailDescription() {
        const { timesheetDetail } = this.props;

        const { equipment, employee } = timesheetDetail;

        if (employee && employee.id) {
            return `${employee.lastName}, ${employee.firstName}`;
        }

        return `${equipment.description} (#${equipment.identifier})`;
    }

    getPriorTimesheetDetailContractPhase() {
        const { timesheet, timesheetDetailContractPhaseAdjustment } =
            this.props;

        if (
            !timesheetDetailContractPhaseAdjustment ||
            !timesheetDetailContractPhaseAdjustment.timesheetDetailContractPhaseId
        ) {
            return null;
        }

        const timesheetDetail = timesheet.timesheetDetails.find(
            (td) =>
                td.id ==
                timesheetDetailContractPhaseAdjustment.timesheetDetailId
        );

        if (!timesheetDetail) {
            return null;
        }

        return timesheetDetail.timesheetDetailContractPhases.find(
            (tdcp) =>
                tdcp.id ==
                timesheetDetailContractPhaseAdjustment.timesheetDetailContractPhaseId
        );
    }

    onTimesheetDetailContractPhaseQuantityChange = (e) => {
        if (!e || !e.target) {
            return;
        }

        const entityInQuestion = this.getEntityInQuestion();

        const quantity = e.target.valueAsNumber;

        const { timesheet, isAdmin, onTimesheetMutated, job } = this.props;

        if (isAdmin) {
            onAdminQuantityChange(
                timesheet,
                job,
                entityInQuestion.contractPhaseId,
                entityInQuestion.timesheetDetailId,
                quantity
            );
        } else {
            onFieldUserQuantityChange(
                timesheet,
                entityInQuestion.contractPhaseId,
                entityInQuestion.timesheetDetailId,
                quantity
            );
        }

        onTimesheetMutated(timesheet);
    };

    getEntityInQuestion = () => {
        const {
            timesheetDetailContractPhase,
            timesheetDetailContractPhaseAdjustment,
        } = this.props;

        return (
            timesheetDetailContractPhaseAdjustment ??
            timesheetDetailContractPhase
        );
    };

    render() {
        const {
            loading,
            timesheetDetailContractPhase,
            timesheetDetailContractPhaseAdjustment,
            job,
            isReadOnly,
        } = this.props;
        const { showModal } = this.state;

        if (
            loading ||
            (!timesheetDetailContractPhase &&
                !timesheetDetailContractPhaseAdjustment)
        ) {
            return null;
        }

        const entityInQuestion = this.getEntityInQuestion();

        const contractPhase = job.contract.contractPhases.find(
            (cp) => entityInQuestion.contractPhaseId == cp.id
        );

        const priorTimesheetDetailContractPhase =
            this.getPriorTimesheetDetailContractPhase();

        if (!contractPhase) {
            return (
                <div className="grid-col">
                    <Card className="timesheet-detail-contract-phase-card">
                        <CardBody>
                            {toNumberSafe(entityInQuestion.quantity) > 0 && (
                                <div>
                                    {toNumberSafe(entityInQuestion.quantity)}{' '}
                                    hrs
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </div>
            );
        }

        const detailDescription = this.getDetailDescription();
        const entityQuantity = toNumberSafe(entityInQuestion.quantity);

        return (
            <div
                className="grid-col"
                key={`tdcpb-${entityInQuestion.timesheetDetailId}-${entityInQuestion.contractPhaseId}`}
            >
                <Card
                    className="timesheet-detail-contract-phase-card"
                    onClick={this.toggleModal}
                >
                    <CardHeader
                        className={cls({ disabled: !this.isEditEnabled() })}
                    >
                        {contractPhase.displayPhase}

                        {Boolean(
                            timesheetDetailContractPhaseAdjustment ||
                            entityInQuestion.clientAdjustment
                        ) && <FontAwesomeIcon icon={faEdit} className="ml-1" />}
                    </CardHeader>

                    <CardBody>
                        {entityQuantity != 0 && <>{entityQuantity} hrs</>}

                        {entityQuantity == 0 && <>&nbsp;</>}
                    </CardBody>
                </Card>

                <Modal
                    isOpen={showModal}
                    fade={false}
                    autoFocus={false}
                    size="xl"
                >
                    <ModalHeader toggle={this.toggleModal}>
                        {detailDescription}
                    </ModalHeader>
                    <ModalBody>
                        <AdjustmentDetail
                            entity={entityInQuestion}
                            {...this.props}
                        />

                        <div>
                            <div>
                                Please enter the hours worked for{' '}
                                {contractPhase.displayPhase} (
                                {contractPhase.description}).
                            </div>
                            <div>
                                <InputGroup>
                                    <Input
                                        type="number"
                                        inputMode="decimal"
                                        step={0.25}
                                        value={entityInQuestion.quantity}
                                        onChange={
                                            this
                                                .onTimesheetDetailContractPhaseQuantityChange
                                        }
                                        autoFocus={true}
                                        disabled={isReadOnly}
                                    />
                                    <InputGroupText>hrs</InputGroupText>
                                </InputGroup>
                            </div>
                            {priorTimesheetDetailContractPhase && (
                                <div className="mt-3">
                                    <div>Original hours worked</div>
                                    <div>
                                        <InputGroup>
                                            <Input
                                                type="number"
                                                step={0.25}
                                                value={
                                                    priorTimesheetDetailContractPhase.quantity
                                                }
                                                disabled={true}
                                            />
                                            <InputGroupText>hrs</InputGroupText>
                                        </InputGroup>
                                    </div>
                                </div>
                            )}
                        </div>
                    </ModalBody>
                    <ModalFooter hidden={isReadOnly}>
                        <Button
                            type="button"
                            onClick={this.toggleModal}
                            color="success"
                        >
                            Done
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
